import { render, staticRenderFns } from "./TaxRiskEvaluate.vue?vue&type=template&id=128137b1&scoped=true&"
import script from "./TaxRiskEvaluate.vue?vue&type=script&lang=js&"
export * from "./TaxRiskEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./TaxRiskEvaluate.vue?vue&type=style&index=0&id=128137b1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128137b1",
  null
  
)

export default component.exports